import './index_mWeb.css';
import { BsArrowDown, BsArrowUp } from 'react-icons/bs';
import I18n from '../../../utilities/locale';
import React, { useEffect, useState } from 'react';
import Constants from '../../../constants';
import useTheme from '../../../utilities/hooks/theme';
import { View, Card } from '../../../component';

const UpIcon = () => {
  return (
    <View className="contest-sorting-icon-wrapper">
      <BsArrowUp size={18} fill={'#9a9b9e'} />
    </View>
  );
};

const DownIcon = () => {
  return (
    <View className="contest-sorting-icon-wrapper">
      <BsArrowDown size={18} fill={'#9a9b9e'} />
    </View>
  );
};

interface IconButtonProps {
  isAllContestList?: boolean;
  title?: string;
  sortType?: string;
  theme?: any;
  onPress?: React.MouseEventHandler;
}

const IconButton = ({ onPress, isAllContestList, title, sortType }: IconButtonProps) => {
  const sortTypeColor = {
    color: '#fff'
  };

  const IconButtonBG = {
    backgroundColor: '#32363e'
  };

  return (
    <View className="contest-sorting-icon-btn-wrapper_mWeb" style={IconButtonBG} onPress={onPress}>
      <p className="contest-sorting-icon-btn-label_mWeb" style={sortTypeColor}>
        {title}
      </p>
      {isAllContestList && sortType != '' && (sortType === 'UP' ? <UpIcon /> : <DownIcon />)}
    </View>
  );
};

const ContestSortingHeaderMWeb = ({
  onUpdateChallenge,
  onPressFilter,
  challenges,
  defaultSort,
  isAllContestList = false,

  onPressSpots,
  onPressWinner
}: any) => {
  useEffect(() => {
    if (defaultSort === 'Winner') {
      setWinner('UP');
    } else if (defaultSort === 'Spots') {
      setSpots('UP');
    }
  }, []);

  const { FantasyTheme: theme } = useTheme();
  // const [prizePool, setPrizePool] = useState(''); //UP or DOWN
  const [winner, setWinner] = useState(''); //UP or DOWN
  const [spots, setSpots] = useState(''); //UP or DOWN

  const onClickWinners = () => {
    const myWinner = winner === '' ? 'DOWN' : winner === 'DOWN' ? 'UP' : 'DOWN';
    setWinner(myWinner);
    // setPrizePool('');
    setSpots('');
    // setEntry('');
    if (myWinner === 'DOWN') {
      onUpdateChallenge(
        challenges.sort((a: any, b: any) => {
          const aLen = Object.keys(a.winningsPerPosition).length || 0;
          const bLen = Object.keys(b.winningsPerPosition).length || 0;
          return aLen - bLen;
        })
      );
    } else {
      onUpdateChallenge(
        challenges.sort((a: any, b: any) => {
          const aLen = Object.keys(a.winningsPerPosition).length || 0;
          const bLen = Object.keys(b.winningsPerPosition).length || 0;
          return bLen - aLen;
        })
      );
    }
  };

  const onClickSpots = () => {
    const mySpots = spots === '' ? 'DOWN' : spots === 'DOWN' ? 'UP' : 'DOWN';
    setSpots(mySpots);
    setWinner('');
    // setEntry('');
    if (mySpots === 'DOWN') {
      onUpdateChallenge(challenges.sort((a: any, b: any) => a.maximumPlayers - b.maximumPlayers));
    } else {
      onUpdateChallenge(challenges.sort((a: any, b: any) => b.maximumPlayers - a.maximumPlayers));
    }
  };

  const sortedBG = {
    backgroundColor: '#32363e'
  };

  useEffect(() => {
    if (defaultSort === 'Winner') {
      setWinner('UP');
    } else {
      setSpots('UP');
    }
  }, []);

  return (
    <Card
      style={{
        backgroundColor: '#192330'
      }}
      className="contest-sorting-container_mWeb">
      <IconButton
        title={I18n.t('SPOTS')}
        sortType={spots}
        isAllContestList={isAllContestList}
        theme={theme}
        onPress={isAllContestList ? onClickSpots : onPressSpots}
      />

      <IconButton
        title={I18n.t('WINNERS')}
        sortType={winner}
        isAllContestList={isAllContestList}
        theme={theme}
        onPress={isAllContestList ? onClickWinners : onPressWinner}
      />

      <View
        style={sortedBG}
        className="contest-sorting-icon-btn-wrapper_mWeb"
        onPress={onPressFilter}>
        <Constants.Svgs.FilterList fill={'#fff'} width={20} height={20} />
      </View>
    </Card>
  );
};
export default React.memo(ContestSortingHeaderMWeb);
